export class EmailAlreadyInUseError extends Error {
  constructor(message?: string) {
    super(message ?? "Email already in use");
    this.name = "EmailAlreadyInUseError";
  }
}
